import SimpleSlideshow from 'site/components/SimpleSlideshow'
const swipe = require('imports/jquery-touchswipe/jquery.touchSwipe.min.js')
let simpleSlideshowPrep = {
    innerSlideTopArray:[],
    topIndex:1,
    slidesTop:null,
    whatWasIt: null,

    init: function () {
        //$(window).on("resize", simpleSlideshowPrep.reinitSlides)
        simpleSlideshowPrep.reinitSlides()
    },//init
    reinitSlides: function() {
        let sw = $(window).width()
        let oldMode = simpleSlideshowPrep.whatWasIt
        let newMode = ''

        if (sw >=window.mobileBreakpoint ) {
            //desktop
            newMode = 'desktop'
        } else {
            newMode = 'mobile'
        }//

        if (oldMode !== newMode) {
            simpleSlideshowPrep.whatWasIt = newMode

            //reinit
            let thtml = $('#swiper-og').html()
            $('#slides-top').html(thtml)
            /*
            if (newMode === 'mobile') {
                //remove #1
                $('#slides-top .swiper-slide-1').remove();

                //kill old numbering
                setTimeout(function( ) {
                    $('#slides-top .swiper-slide').each(function (index) {
                        for (let i = 0;i<140;i++) {
                            $(this).removeClass('swiper-slide-'+ i)
                        }
                    })

                    //add new numbering
                    let i = 1
                    $('#slides-top .swiper-slide').each(function (index) {
                        $(this).addClass('swiper-slide-'+ i)
                        i++
                    })
                },10)

            }

             */

            //add new listeners
            $('#slides-top .button-end').click(simpleSlideshowPrep.startOver)
            $('#slides-top .chapter-links .link').click(simpleSlideshowPrep.chapterLink)

            simpleSlideshowPrep.setupSlides()
        }
    },
    setupSlides: function () {
        let totalSlides = $("#slides-top .swiper-wrapper .swiper-slide-primary").length

        let slidesTop = new SimpleSlideshow('#slides-top')

        slidesTop.init()

        //initial
        slidesTop.setIndicators(slidesTop, 0)
        simpleSlideshowPrep.slidesTop = slidesTop

        //if ($('body').hasClass('browser-safari')) {

            $('#slides-top').bind('touchmove', function(e) {
                //return false
            })
            $('#slides-top').bind('touchstart', function(e) {
                slidesTop.safariClick(true)
                //e.preventDefault()
            })


        //}
    },
    startOver: function () {
        simpleSlideshowPrep.slidesTop.slider.slideTo(0)
        simpleSlideshowPrep.slidesTop.safariClick(true)
    }
}
export default simpleSlideshowPrep
